import { InjectionToken } from '@angular/core';
import { Page } from '@app/app/shared/models/page';
import { ObservableResult } from '@app/app/shared/store';
import { RegistrationDecision, RegistrationDecisionResult, RegistrationRequest, RegistrationsQuery } from './registration.model';

export const REGISTRATIONS_DATA_SERVICE = new InjectionToken<RegistrationsDataService>('[Admin] RegistrationsDataService');

/** Registration requests on the content the current user manages or approves. Failures carry the API's message, or none. */
export interface RegistrationsDataService {
  list(query: RegistrationsQuery): ObservableResult<Page<RegistrationRequest>>;

  /** One result per record, whether or not it could be decided. */
  decide(enrolmentUids: string[], decision: RegistrationDecision, reason?: string): ObservableResult<RegistrationDecisionResult[]>;
}
